import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { Tooltip } from "react-tooltip";
import classnames from "classnames";

// interface
import { BasicDetailsTypes } from "../../../data/settings";
import { Const } from "const";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { ucChatAlighRight } from "../../../redux/profile2/p2_reducer";
import { Utils } from "helpers/utils";
import { setPermNotification } from "../../../redux/actions";
import { deleteToken, getToken } from "firebase/messaging";
import { messaging } from "../../../../src/helpers/firebase-config";
import { updateFcmTokenAsync } from "../../../../src/api/profile";
import { APIClient } from "api/apiCore";

declare function askForPushNotification(bSilent: boolean): Promise<string>;
declare function isNotificationPermissionGranted(): boolean;

interface SystemSettingProps {
  // basicDetails: BasicDetailsTypes;
}
const SystemSetting = ({ /*basicDetails*/ }: SystemSettingProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Layout,
    (layout) => ({
      isGrantNotification: layout.isGrantNotification
    })
  );

  const { isGrantNotification } = useAppSelector(storeData);

  // useEffect(() => {
  //   console.log('System Setting');
  // }, []);

  const [tipCopyDeviceIdOpen, setTipCopyDeviceIdOpen] = useState<boolean>(false);
  const [deviceId, setDeviceId] = useState<string>(localStorage.getItem("did4") ?? "");
  const [fcmLogs, setFcmLogs] = useState<any>(Utils.GetLogFcm());
  const [isPushSupport, setIsPushSupport] = useState<boolean>(isNotificationPermissionGranted() !== undefined);
  const [fcmToken, setFcmToken] = useState<string>(localStorage.getItem('ftk') ?? "");
  // console.log('fcmLog:', fcmLogs);
  const onCopyDeviceId = async () => {
    try {
      const storeId = localStorage.getItem("did4") ?? "";
      await navigator.clipboard.writeText(storeId);
      setDeviceId(storeId);
      setTipCopyDeviceIdOpen(true);
      setTimeout(() => { setTipCopyDeviceIdOpen(false); }, 1000);
    } catch (e) {
      alert((e as any).message);
    }
  }

  let fcmLosgMsg = Array();

  const fnAskperm = async () => {
    try {
      // alert([
      //   'Notification Permission=' + Notification.permission,
      //   'Is notification grant=' + isNotificationPermissionGranted()
      // ]);

      // askForPushNotification(false);
      // dispatch(setPermNotification(isNotificationPermissionGranted()));
      askForPushNotification(false)
        .then((permission: any) => {
          dispatch(setPermNotification(permission === 'granted'));
        })
        .catch((error: any) => {
          console.error('Failed to get notification permission:', error);
        });

    } catch (e) {
      alert((e as Error).message);
    }
  }

  const onButtonNotSupportNotificationClick = () => {
    try {
      const deviceOs = Utils.GetDeviceOS();
      const browser = Utils.GetBrowser();
      const agent = navigator.userAgent;

      if (isPushSupport) {
        alert(`OS<br/><span class="text-success">${deviceOs}</span><br/>Browser<br/><span class="text-success">${browser}<br/>${agent}</span></br/>นี้รองรับการแจ้งเตือน`);
      } else {
        alert(`OS<br/><span class="text-red">${deviceOs}</span><br/>Browser<br/><span class="text-red">${browser}<br/>${agent}</span></br/>นี้ไม่รองรับการแจ้งเตือน\nอาจต้องติดตั้งแอปก่อน`);
      }
    } catch (e) {
      alert((e as any).message);
    }
  }

  const saveTokenToServer = async () => {
    try {
      if (Utils.IsViewAs()) {
        fcmLosgMsg.push('Not support is view as mode');
        return;
      }
      let currentToken = localStorage.getItem('ftk');
      if (!currentToken) {
        fcmLosgMsg.push('Not found stored token');
        //console.log('No token stored');
        return;
      }
      // console.log('saveTokenToServer');
      const response = await updateFcmTokenAsync(currentToken);
      fcmLosgMsg.push('Updated token with status = ' + response.status);
      // console.log('await updateFcmTokenAsync(currentToken):', response);

      if (response.status === 409) {
        //console.log("Already subscribed");
      }
      const json = JSON.parse(await response.text());

      // dispatch(setIsFakeSmsMode(json.apiInfo.fakeSms));
    } catch (e) {
      const er = e as Error;
      if (er.message == "Failed to fetch") {
        // connection to server is lose
      } else {
        fcmLosgMsg.push((e as Error).message);
      }
    }
  }

  const fnSubscribe = async () => {
    try {
      fcmLosgMsg = new Array();
      const fnSubscribe2 = async () => {
        try {
          if (isNotificationPermissionGranted()) {
            fcmLosgMsg.push('Subscribe for FCM token');
            const fcmLocal = localStorage.getItem('ftk') ?? '';
            try {
              await deleteToken(messaging);
            } catch (e2) {
              fcmLosgMsg.push('Delete token failed:' + (e2 as any).message);
            }
            const fcmToken = await getToken(messaging, { vapidKey: process.env.REACT_APP_VAPID_KEY, });
            console.log('fcmToken:' + fcmToken);
            if (fcmLocal && fcmLocal != fcmToken) {
              fcmLosgMsg.push('Current local token not same with new token');
            } else {
              fcmLosgMsg.push('New token same with current token');
            }

            if (fcmToken) {
              localStorage.setItem('ftk', fcmToken);
              await saveTokenToServer();
              fcmLosgMsg.push('subscribe FCM success');
            } else {
              fcmLosgMsg.push('Cannot get FCM tokne');
            }
          } else {
            fcmLosgMsg.push('Not get token because notification is not granted');
          }
        } catch (e2) {
          fcmLosgMsg.push((e2 as any).message);
        }
        const msg = fcmLosgMsg.map((e: any) => '-' + e).join('<br/>');
        setFcmToken(localStorage.getItem('ftk') ?? "");
        alert(msg);
      }

      if (fcmToken == "") {
        Utils.SweetConfirm(`ยืนยันยันการ subscribe push กับ FCM`)
          .then((result) => { if (result.isConfirmed) fnSubscribe2() })
          .catch((error) => window.alert((error as any).message));
      } else {
        Utils.SweetConfirm(`อุปกรณ์ของท่าน ได้ทำการ subscribe กับ FCM แล้ว ต้องการทำอีกครั้งหรือไม่`)
          .then((result) => { if (result.isConfirmed) fnSubscribe2() })
          .catch((error) => window.alert((error as any).message));
      }
    } catch (e) {
      window.alert((e as any).message);
    }
  }

  const fnPushMe = async () => {
    try {
      const api = new APIClient
      const token = await Utils.GetFCMToken(true);
      const parm = { endpoint: token, p256dh: '', auth: '' }
      const resp = await api.fnPostForm("/push-me", parm);
      if (resp.success) {
        alert(resp.data);
      } else {
        alert(resp.message);
      }
    } catch (e) {
      alert((e as any).message);
    }

  }

  const onClickViewFcmToken = async () => {
    try {
      await navigator.clipboard.writeText(fcmToken);
      alert(fcmToken);
    } catch (e) {
      alert((e as any).message);
    }
  }

  return (
    <div className="accordion-body " style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

      <div >
        <p className="text-primary mb-1">Device ID</p>
        <div className="d-flex justify-content-between align-items-center row">
          <div className="col">
            {deviceId}&nbsp;
            <i className='bx bx-copy hand text-secondary' data-tooltip-id="tipCopyDeviceId" data-tooltip-content="คัดลอกแล้ว" onClick={onCopyDeviceId} ></i>
            <Tooltip id="tipCopyDeviceId" isOpen={tipCopyDeviceIdOpen} />
          </div>
        </div>
      </div>

      <div >
        <p className="text-primary mb-1">สิทธิ์แจ้งเตือน</p>
        <div className="d-flex justify-content-between align-items-center row">
          <div className="col">

            <button id="btnNotSupportPush"
              className={classnames("btn btn-sm btn-compact w-100 mb-1", { "btn-warning": !isPushSupport, "btn-primary": isPushSupport })}
              type="button"
              onClick={onButtonNotSupportNotificationClick}
            >{isPushSupport ? "Browser รองรับแจ้งเตือน" : "Browser ไม่รองรับแจ้งเตือน"}</button>

            <button
              id="btnAskPerm"
              className={classnames("btn btn-sm btn-compact w-100 mb-1", { "btn-danger": !isGrantNotification, "btn-primary": isGrantNotification })}
              type="button"
              onClick={fnAskperm}
            >{isGrantNotification ? "ได้สิทธิ์แจ้งเตือนแล้ว" : "เปิดสิทธิ์แจ้งเตือน"}</button>

            <div className="input-group">
              <button
                id="btnFcmToken"
                className={classnames("btn btn-sm btn-compact form-control mb-1", { "btn-danger": fcmToken == "", "btn-primary": fcmToken != "" })}
                type="button"
                onClick={fnSubscribe}
              >{fcmToken == "" ? "ยังไม่ subscribe push" : "subscribe push แล้ว"}</button>
              <div className="input-group-append">
                <button className="btn btn-outline-info btn-sm" onClick={onClickViewFcmToken}>
                  <span className="mdi mdi-eye-outline"></span>
                </button>
              </div>
            </div>

            <button
              id="btnTestPush"
              className={classnames("btn btn-sm btn-compact btn-warning w-100 mb-1")}
              type="button"
              onClick={fnPushMe}
            >TEST PUSH NOTIFICATION</button>




          </div>
        </div>
      </div>

      {/* <div >
        <p className="text-primary mb-1">FCM Log</p>
        <div className="d-flex justify-content-between align-items-center row">
          <div className="col">
            <ul style={{paddingLeft:"1em"}}>
              {fcmLogs.map((msg: string, index: number) => (
                <li key={index} >{msg}</li>
              ))}
            </ul>
          </div>
        </div>
      </div> */}

    </div>
  );
};

export default SystemSetting;
